export default {
    meta: {
        title: 'Appliquer pour un prêt personnel | Fig Financial',
        description: 'Recevez un offre de prêt en quelques secondes et complétez votre demande en quelques minutes, tout depuis le confort de votre maison.'
    },
    home: {
        title: '' // Home
    },
    cta: {
        buttonText: 'Continuer', // Continue
        disclaimerText: "Ceci n'affectera pas votre cote de crédit", // This will not impact your credit score
        disclaimerIconAlt: "Icône d'avertissement" // Disclaimer icon
    },
    loading: {
        title: 'Chargement...' // Loading...
    },
    error: {
        generic: {
            title: 'Oups, une erreur s’est produite', // Oops, something’s gone wrong
            subtitle: `Nous travaillons à résoudre ce problème dès que possible. Cliquez sur le bouton « Réessayer » ou contactez-nous via le <liveChatLink>chat en direct Fig</liveChatLink> ou par <supportLink>email au support Fig.</supportLink>`,
            buttonText: 'Réessayer' // Try again
        },
        404: {
            title: 'Lien incorrect', // Oops! We couldn't find that page
            subtitle:
                'Le lien que vous avez demandé n’a pas été trouvé. Ne vous inquiétez pas — votre progression de réservation de prêt est sauvegardée et vous pouvez continuer là où vous vous êtes arrêté.', // The page you’re looking for doesn’t exist. Don’t worry — your loan booking progress is safe and you can continue where you left off.
            goBack: 'Retour', // Go back
            contactUs: 'Accéder au centre d’aide' // Contact us
        }
    },
    common: {
        progressBarEstimate: 'Encore quelques minutes pour finir', // Just a few minutes to finish
        otpSection: {
            resendMessage: "Vous n'avez pas reçu le code?",
            resendButton: 'Renvoyer'
        },
        date: {
            label: 'Date de naissance', // Date of Birth
            month: 'Mois',
            day: 'Jour',
            year: 'Année',
            months: {
                1: 'Janvier',
                2: 'Février',
                3: 'Mars',
                4: 'Avril',
                5: 'Mai',
                6: 'Juin',
                7: 'Juillet',
                8: 'Août',
                9: 'Septembre',
                10: 'Octobre',
                11: 'Novembre',
                12: 'Décembre'
            }
        },
        FigDatePicker: {
            placeholder: 'Sélectionnez une date',
            useCalendarWarning: 'Veuillez sélectionner une date à l’aide du calendrier.'
        },
        alt: {
            figLogo: 'Logo Fig', // Fig Logo
            figEliteLogo: 'Logo Fig Elite',
            partnerNavLogo: 'Logo {{partnerName}}',
            kizzoLogo: 'Logo Kizzo', // Kizzo Logo
            partnerLogo: 'Logo {{name}}',
            verificationFailed: 'Échec de la vérification', // Verification Failed
            handCheckmark: 'Main avec coche', // Hand Checkmark
            congratulations: 'Félicitations', // Congratulations
            flinksLogo: 'Flinks', // Flinks
            successIcon: 'Succès', // Success
            loanComplete: 'Prêt complété', // Loan Complete
            disclaimer: 'Avertissement', // Disclaimer
            lightbulb: 'Icône d’information', // Information icon
            phone: 'Icône de téléphone', // Phone icon
            pencilEdit: 'Icône d’édition', // Edit icon
            languageFlag: 'Icône de drapeau pour le sélecteur de langue', // Flag icon for the locale switcher
            notFound: '404 Introuvable', // 404 Not Found
            maintenance: 'Nous mettons à jour nos systèmes actuellement' // We're updating our systems currently
        }
    },
    PleaseReachOut: {
        contactFigLabel: 'l’équipe de soutien de Fig',
        liveChatLabel: 'clavardage en direct avec Fig',
        content: 'communiquez avec nous au moyen du <2/> qui se situe au coin inférieur droit de cette page ou envoyez un courriel à <4/>.'
    },
    maintenance: {
        title: 'Nous mettons à jour nos systèmes actuellement',
        content: `Des travaux de maintenance sont en cours. Pendant cette période, le processus de demande de prêt Fig et l'accès à votre Compte Fig ne seront pas disponibles. Nous prévoyons être de retour dans quelques heures. Merci de votre patience.`
    },
    partner: {
        kizzo: 'KIZZO',
        kizzoPoweredBy: 'de la Financière KIZZO propulsé par Fig',
        fig: 'Fig'
    }
}
